Namespace 'Monitoring.Reports.Campaign'

Monitoring.Reports.Campaign.Utils =

  ancestorIdForPost: (post) ->
    if post.type != 'instagramMedia' then post.id else post.post_id

  paramsForChildsOfPosts: (extra_params) ->
    ancestors = _.map @options.posts, (post) => @ancestorIdForPost(post)
    params = 
      account_id:    @options.account_id
      date_from_ISO: @options.date_from_ISO
      date_to_ISO:   @options.date_to_ISO
      timezone:      @options.timezone
      ancestors:     ancestors
    return params unless extra_params
    merge params, extra_params
